module.exports = __webpack_public_path__ + "static/media/06.802f887b.mp3";